import { gql } from '@apollo/client';

export const CREATE_ROTATIONSPLAN = gql`
  mutation mitarbeiter_createRotationsplan(
    $input: mitarbeiter_createRotationsplanInput!
  ) {
    mitarbeiter_createRotationsplan(createRotationsplanInput: $input) {
      id
      abschnitte {
        id
      }
      mitarbeiter {
        id
        nachname
        vorname
      }
      beruf {
        id
      }
    }
  }
`;
